<template>
    <div class="model_service_box" v-show="CBshow">
        <div class="shadowPage" style=""></div>
        <div class="toolContainer" >
            <div class="pc-title">
                <span class="pc-head">下载详情</span> 
                <span class="layui-layer-setwin"  @click="Hidden">
                    <a href="javascript:;" class="layui-layer-ico layui-layer-close layui-layer-close1"></a>
                </span>
            </div> 
            <div class="clearfix" style="padding-top: 22px; padding-right: 16px;">
                <div class="toolLeft">
                    <div class="img_box">
                        <img src="../../static/img/tool/icon_khd.gif" alt=""></div>
                        <div class="otherdownloadBox">
                             <a href="https://static.3dmomoda.com/client/CampusBuilder2020x64_cn.zip"><div class="otherdownloadBtn" >
                               下载
                            </div></a>
                        </div> 
                        <!-- <div class="downloadBox">
                             <a href="http://thumb.static.3dmomoda.com/client/momoda_client64_cn.exe"><div class="downloadBtn" >
                               稳定版下载
                            </div></a>
                        </div>  -->
                    <div class="link_box">
                        <a href="https://share.weiyun.com/DXMHGfXu" target="_blank">腾讯微云</a>
                        <!-- <a href="https://yadi.sk/d/mvUL2NzoVmQmag" target="_blank">海外网盘</a> -->
                    </div>
                </div>
            <div class="toolRight">
                <h3 style="font-size: 16px; font-weight: normal;">CampusBuilder客户端</h3>
                <ul class="tool_info_ul">
                    <li>
                        <div class="item_left">版本号:</div>
                        <div class="item_right" style="font-size: 12px;">1.2.1.273</div>
                    </li>
                    <li>
                        <div class="item_left">文件大小:</div>
                        <div class="item_right" style="font-size: 12px;">1.11GB</div>
                    </li>
                    <li>
                        <div class="item_left">更新时间:</div>
                        <div class="item_right" style="font-size: 12px;">2022/11/10</div>
                    </li>
                    <li>
                        <div class="item_left">MD5:</div>
                        <div class="item_right" style="font-size: 12px;">493b9f6d9bf877c79d7b2e24e5cb12b7</div>
                    </li>
                    <li>
                        <div class="item_left">介绍:</div>
                        <div class="item_right" style="font-size: 12px; word-break: break-all;">CampusBuilder（模模搭）支持本地3D场景搭建；无需专业建模知识，普通人即可快速构建3D场景；所搭3D场景能自动同步到ThingJS网站</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: "modeling_box",
    data: function() {
        return{
            panelShow11:true,
            CBshow:true,
        }
    },
    methods: {
        Hidden:function(){
            this.CBshow = false;
            this.panelShow11 = false;
            this.$emit('closePanel');

        }
    },
}
</script>
<style lang="">
    @import '../assets/css/tool.css';
</style>



// WEBPACK FOOTER //
// src/components/CBUpload.vue